import Vue from 'vue'

// 更新公用枚举值
export function updateEnumConf(state, payload) {
  state.enumConf = payload
}

// 更新广告配置
export function updateAdConf(state, payload) {
  state.adConf = payload
}

// 设置品牌门店树形数据
export function setBrandShopOptions(state, payload) {
  state.brandShopFilter.brandShopOptions = payload
  // 构建 brandShopMap，以 brandId 为 key，品牌对象为 value
  state.brandShopFilter.brandShopMap = {}
  payload.forEach(brand => {
    state.brandShopFilter.brandShopMap[brand.brandId] = brand
  })
}

// 更新选中的品牌ID列表
export function updateSelectedBrandIds(state, brandIds) {
  state.brandShopFilter.selectedBrandIds = brandIds
}

// 更新某品牌下选中的门店
export function updateShopSelection(state, { brandId, shopIds }) {
  Vue.set(state.brandShopFilter.selectedShopMap, brandId, shopIds)
}

// 重置品牌门店选择
export function resetBrandShopSelection(state) {
  state.brandShopFilter.selectedBrandIds = []
  state.brandShopFilter.selectedShopMap = {}
}

// 批量更新品牌门店选择
export function batchUpdateBrandShopSelection(state, { selectedBrandIds, selectedShopMap }) {
  state.brandShopFilter.selectedBrandIds = selectedBrandIds
  state.brandShopFilter.selectedShopMap = selectedShopMap
}

// 初始化全选状态（默认全选所有品牌所有门店）
export function initAllBrandsSelected(state) {
  const brandShopOptions = state.brandShopFilter.brandShopOptions
  const selectedBrandIds = []
  const selectedShopMap = {}

  brandShopOptions.forEach(brand => {
    selectedBrandIds.push(brand.brandId)
    selectedShopMap[brand.brandId] = brand.shopList.map(shop => shop.shopId)
  })

  state.brandShopFilter.selectedBrandIds = selectedBrandIds
  state.brandShopFilter.selectedShopMap = selectedShopMap
}
